module.exports = __webpack_public_path__ + "img/dark.ba39742c.png";